import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container: any = styled.div`
  width: 966px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  &.with-filters {
    margin-bottom: 8px;
  }
`;

Container.Title = styled.div`
  margin-left: 16px;
`;

export const Subtitle = styled.h3`
  font-size: 14px;
  line-height: 1.4em;

  & > span > strong {
    color: ${ColorPalette.HEX.BrightOrange};
    font-weight: 600;
    font-size: 16px;
  }

  & > strong {
    color: ${({ theme }) => theme.primaryBackgroundColor};
    font-weight: 600;
    font-size: 16px;
  }
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.7px;
  line-height: 1.4em;
`;

export const MapSwitch = styled.div``;
